// # 웹 진입점
//
// 여기서 하는 일은 **플랫폼 구현을 고르고 문을 붙이는 것**뿐이다.
// 데스크톱 진입점(`apps/desktop`)과 다른 줄은 사실상 이 파일 한 줄이다.

import { Gate } from '@maru/app'
import '@maru/app/style.css'
import { AuthApi, session_open, token_seat } from '@maru/client'
import { device_label } from '@maru/platform'
import { WebPlatform } from '@maru/platform/web'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

const query_client = new QueryClient({
  defaultOptions: {
    queries: {
      // 메시지는 소켓이 밀어 준다. Query 가 주기적으로 다시 긁을 이유가 없다.
      // **긁게 두면 소켓과 경쟁해서 타임라인이 깜빡인다.**
      refetchOnWindowFocus: false,
      staleTime: Number.POSITIVE_INFINITY,
      retry: 2,
    },
  },
})

// 같은 오리진이다. 개발은 Vite 프록시, 운영은 리버스 프록시가 `/v1` 을 API 로 보낸다.
const auth = new AuthApi({ base_url: '', device: device_label(navigator.userAgent, '웹') })
const seat = token_seat(auth)
const Session = session_open({ base_url: '', token: () => seat.token() })

const root = document.getElementById('root')
if (!root) throw new Error('#root 가 없다 — index.html 이 바뀌었나?')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={query_client}>
      <Gate
        auth={auth}
        seat={seat}
        session={Session}
        platform={WebPlatform()}
        // 서브도메인 꼴(`acme.maru.example`)은 와일드카드 DNS·인증서가 있는 배포만 켠다. 없으면 `/w/acme`.
        org_domain={import.meta.env.VITE_MARU_ORG_DOMAIN ?? null}
      />
    </QueryClientProvider>
  </StrictMode>,
)

// 개발 서버에서는 워커를 걸지 않는다 — 캐시가 핫 리로드를 가로막는다.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.register('/sw.js').catch(() => {})
}
